/** Service Desk console: listahan ng mga Contact, profile drawer at dialog ng pag-apruba ng sasali (C05, SD-S1-46). */
export const serviceContact = {
  subtitle: "Ang mga taong nasa likod ng bawat ticket at order: sino sila, paano sila na-verify, at ano ang puwede nilang i-order.",
  actions: { import: "I-import ang mga contact" },
  filters: {
    group: "Mga filter ng contact",
    search: "Hanapin ang pangalan o e-mail…",
    searchLabel: "Maghanap ng contact",
    organisation: "Organisasyon",
    allOrganisations: "Lahat ng organisasyon",
    all: "Lahat",
    pending: "Naghihintay",
    admins: "Mga org admin",
    unlinked: "Walang organisasyon",
    blocked: "Naka-block",
    clear: "I-clear ang mga filter",
  },
  banner: {
    pending_one: "{{count}} sasali ang naghihintay ng pag-apruba.",
    pending_other: "{{count}} sasali ang naghihintay ng pag-apruba.",
    signedIn: "Nag-sign in si {{name}} gamit ang domain na {{domain}}.",
    show: "Ipakita ang naghihintay",
  },
  table: {
    label: "Mga Contact",
    name: "Pangalan",
    organisation: "Organisasyon",
    role: "Tungkulin sa org",
    verified: "Na-verify",
    ordering: "Pag-order",
    language: "Wika",
    noOrganisation: "Walang organisasyon",
    approver: "Taga-apruba",
    cannotOrder: "Hindi puwedeng mag-order",
    limit: "Limitasyon: {{amount}}",
    noLimit: "Walang limitasyon",
    showing: "Ipinapakita ang {{shown}} sa {{total}} contact",
    loadMore: "Magpakita pa",
  },
  role: { org_admin: "Admin ng organisasyon", member: "Miyembro" },
  status: { pending_approval: "Naghihintay ng pag-apruba", blocked: "Naka-block", archived: "Naka-archive" },
  language: { en: "English", fil: "Filipino" },
  visibility: { own: "Sarili nilang mga ticket", organisation: "Lahat ng ticket ng organisasyon" },
  empty: {
    title: "Wala pang contact",
    body: "Lumalabas dito ang mga tao kapag nag-file sila ng request, nag-verify ng e-mail o na-import mula sa spreadsheet.",
    filteredTitle: "Walang tugmang contact",
    filteredBody: "Subukan ang ibang filter o hanap.",
  },
  error: { title: "Hindi namin ma-load ang mga contact", body: "May problema sa aming panig. Subukan ulit." },
  drawer: {
    loading: "Nilo-load ang contact",
    notFoundTitle: "Hindi nakita ang contact",
    notFoundBody: "Maaaring natanggal na ito, o mali ang link.",
    errorTitle: "Hindi namin ma-load ang contact na ito",
    pendingTitle: "Naghihintay ng pag-apruba.",
    pendingBody: "Sumali gamit ang domain na {{domain}} at na-verify ang e-mail sa pamamagitan ng code. Wala silang makikita hangga't hindi mo inaapruba.",
    pendingBodyNoDomain: "Humiling sumali sa organisasyong ito. Wala silang makikita hangga't hindi mo inaapruba.",
    review: "Suriin",
    blockedBanner: "Naka-block ang contact na ito. Tinatanggihan ang mga bagong request nila.",
    archivedBanner: "Naka-archive ang contact na ito.",
    profile: "Profile",
    email: "E-mail",
    mobile: "Mobile",
    organisation: "Organisasyon",
    jobTitle: "Posisyon",
    language: "Wika",
    verifiedVia: "Na-verify sa pamamagitan ng",
    verifiedAt: "Na-verify noong",
    notVerified: "Hindi pa na-verify",
    added: "Idinagdag",
    rights: "Tungkulin at karapatan sa pag-order",
    rightsNoOrdering: "Tungkulin at access",
    orgRole: "Tungkulin sa organisasyon",
    orgRoleAdmin: "Admin ng organisasyon (nakikita ang lahat ng ticket ng organisasyon)",
    orgRoleMember: "Miyembro",
    visibilityAdmin: "Palaging nakikita ng mga admin ng organisasyon ang lahat ng ticket ng organisasyon.",
    visibility: "Nakikita",
    mayOrder: "Puwedeng mag-order",
    mayOrderHint: "Sa chat, sa web app at sa Messenger",
    limit: "Limitasyon sa order (₱, kasama ang VAT)",
    saveLimit: "I-save ang limitasyon",
    approver: "Puwedeng mag-apruba ng order",
    approverHint: "Tumatanggap ng mga hiling na pag-apruba mula sa mga kasamahang lampas sa limitasyon",
    readOnly: "Makikita mo ang contact na ito pero hindi mo ito mababago.",
    consent: "Pahintulot at privacy (RA 10173)",
    consentGiven: "Nakatala ang pahintulot",
    consentNotice: "Bersyon ng paunawa: {{version}}",
    consentNone: "Wala pang nakatalang pahintulot.",
    tickets: "Mga ticket",
    ticketsCount: "Mga ticket ({{count}})",
    noTickets: "Walang ticket.",
    noTicketAccess: "Kailangan mo ng access sa ticket para makita ang mga ticket ng taong ito.",
    ticketsError: "Hindi namin ma-load ang mga ticket ng taong ito.",
    verify: "Markahang na-verify (tawag sa telepono)",
    verifyHint: "Kumpirmahing na-check mo ang pagkakakilanlan ng taong ito sa telepono. Naitatala ito kasama ang pangalan mo.",
    verifyConfirmTitle: "Markahan si {{name}} na na-verify?",
    verifyConfirmBody: "Gawin lang ito pagkatapos mong makumpirma kung sino sila sa telepono. Makikitang na-verify ang humihiling sa mga ticket nila.",
    verifyConfirm: "Markahang na-verify",
    verified: "Namarkahan si {{name}} na na-verify",
    roleSaved: "Na-update ang tungkulin sa organisasyon",
    visibilitySaved: "Na-update ang makikita",
    orderingSaved: "Na-update ang karapatan sa pag-order",
    limitSaved: "Na-save ang limitasyon sa order",
    block: "I-block ang contact",
    blockHint: "Hindi makakapagbukas ng bagong request ang naka-block na contact. Nananatili ang kasaysayan nila.",
    blockConfirmTitle: "I-block si {{name}}?",
    blockConfirmBody: "Tatanggihan ang mga bagong request nila hanggang i-unblock mo sila. Hindi nagbabago ang mga umiiral na ticket.",
    blockConfirm: "I-block ang contact",
    blocked: "Na-block si {{name}}",
    unblock: "I-unblock",
    unblockHint: "Makakapagbukas muli ng request ang contact na ito kapag na-unblock.",
    unblocked: "Na-unblock si {{name}}",
  },
  validation: { limit: "Maglagay ng buong bilang ng piso, hindi bababa sa 1." },
  approve: {
    title: "Aprubahan ang sasali",
    why: "Sumali gamit ang domain na {{domain}} (naghihintay ng pag-apruba) at na-verify ang e-mail sa pamamagitan ng code. Wala silang makikita hangga't hindi mo inaapruba.",
    whyNoDomain: "Humiling sumali sa organisasyong ito. Wala silang makikita hangga't hindi mo inaapruba.",
    role: "Tungkulin sa organisasyon",
    visibility: "Nakikita",
    mayOrder: "Puwedeng mag-order sa chat",
    limit: "Limitasyon sa order (₱, kasama ang VAT)",
    decline: "Tanggihan",
    cancel: "Kanselahin",
    confirm: "Aprubahan",
    approved: "Naaprubahan si {{name}}",
    approvedAdmin: "Naaprubahan si {{name}} bilang admin ng organisasyon",
    declined: "Tinanggihan si {{name}}",
    declineTitle: "Tanggihan si {{name}}?",
    declineBody: "Hindi sila idadagdag sa organisasyon at mananatiling karaniwang contact. Puwede silang humingi ng imbitasyon sa admin ng organisasyon.",
    declineConfirm: "Tanggihan",
  },
} as const;
